
// import React, { Component } from "react";

// // reactstrap components
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Row,
//   Col,
//   Button,
//   Collapse,
// } from "reactstrap";
// import { Link } from "react-router-dom";
// import API from "api.js";
// import { setUser } from "action/index.js";
// import { connect } from "react-redux";
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
// import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";

// import SubcategoryTitle from "Datasets/SubcategoryTitle.json";

// const mapStateToProps = (state) => {
//   return {
//     user: state.user,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUser: (user) => dispatch(setUser(user)),
//   };
// };

// class Mock extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       data: false,
//       status: {},
//       questionList: true,
//       questionData: [],
//       qArr: [],
//       qId: null,
//       redirect: false,
//       activeTab: 0,
//     };
//   }

//   getQuestionType = (subcategory) => {
//     const type = parseInt(subcategory);

//     return SubcategoryTitle[type];
//   };

//   componentDidMount() {
//     API({
//       method: "GET",
//       url: "practiceDetail",
//     })
//       .then((data) => {
//         let obj = data.data.data;

//         let status = {};
//         Object.keys(obj).map((val, key) => {
//           status[val] = false;
//         });

//         this.setState({
//           data: obj,
//           status,
//         });
//       })
//       .catch(() => { });
//   }

//   changeTab = (tab) => {
//     this.setState({
//       activeTab: tab,
//     });
//   };

//   render() {
//     const { data, activeTab, questionList } = this.state;
//     console.log("PRactice Detail component");
//     return (
//       // <div className="siteContent multipleCards">
//       <div className="content multipleCards">
//         <DashboardHeader title="See History" />


//         <div className="dashboard-content-wrapper read-aloud-wrapper qlist-header">
//           <Card>
//             <CardHeader>
//               <div className="read-aloud-header w-100">
//                 <div className="header-col-1">
//                   <div className="header-col-content">
//                     <CardTitle tag="h4">
//                       Question Practiced - <span>(past 10 days)</span>
//                     </CardTitle>

//                     <DataTabs
//                       data={data}
//                       activeTab={activeTab}
//                       changeTab={this.changeTab}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </CardHeader>

//             <CardBody>
//               <TabTables
//                 data={data}
//                 activeTab={activeTab}
//                 getQuestionType={this.getQuestionType}
//                 questionList={questionList}
//               />
//             </CardBody>
//           </Card>
//         </div>
//       </div>
//     );
//   }
// }
// export default connect(mapStateToProps, mapDispatchToProps)(Mock);

import React, { useState, useEffect, useCallback } from "react";
import { Card, Collapse, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import API from "api.js";
import { useSelector, useDispatch } from "react-redux";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";
import CalenderIcon from "../assets/images/images_new/calendar-icon.svg";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import SubcategoryTitle from "Datasets/SubcategoryTitle.json";
import EmptyData from "components/EmptyData/EmptyData";

const PracticedDetail = (props) => {
  const [data, setData] = useState(false);
  const [status, setStatus] = useState({});
  const [questionList] = useState(true);
  const [isDate, setIsDate] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null); // Date object
  const [activeDate, setactiveDate] = useState(""); // "dd-mm-yyyy" string key into data
  const [isLoading, setIsLoading] = useState(true);

  const changeDate = (date) => {
    if (!date) return;
    setSelectedDate(date);
    setIsDate(false);

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    const formatted = `${day}-${month}-${year}`; // "18-03-2026"
    setactiveDate(formatted);
  };

  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
  
    console.log("Practiced Detail");
    API({
      method: "GET",
      url: "practiceDetail",
    })
      .then((data) => {
        let obj = data?.data?.data;

        let statusObj = {};
        Object.keys(obj)?.map((val, key) => {
          statusObj[val] = false;
        });

        setData(obj);
        setStatus(statusObj);
           const d = new Date();
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const formatted = `${day}-${month}-${year}`; // "18-03-2026"
    setSelectedDate(new Date());
    setactiveDate(formatted);
      })
      .catch(() => {}).catch(() => {}).finally(() => {
      setIsLoading(false); 
    });
  }, []);

 const getQuestionType = useCallback((subcategory) => {
    const type = parseInt(subcategory);
    // Map subcategory IDs to correct array indices (17 was removed)
    const indexMap = {
      18: 17,
      19: 18,
      20: 19
    };
    const index = indexMap[type] || type;
    console.log("type",SubcategoryTitle[index]);
    
    return SubcategoryTitle[index];
  }, []);

  // The rows for the selected date
  const activeData = data && activeDate && data[activeDate] ? data[activeDate] : null;

  return (
    <div className="siteContent multipleCards">
      <DashboardHeader title="See History" />

      <div className="dashboard-content-wrapper read-aloud-wrapper qlist-header">
        <Card>
          <Card.Header>
            <div className="read-aloud-header w-100">
              <div className="header-col-1">
                <div className="header-col-content">
                  <Card.Title as="h4" style={{ margin: "unset" }}>
                    Question Practiced
                  </Card.Title>
                  {/* <div className="choose-date-wrapper d-flex align-items-center"> */}
                  <div className="choose-date-wrapper d-flex align-items-center flex-wrap justify-content-center gap-2 gap-md-0">
                    <div className="attempted-question-btn mr-3">
                      Selected Date:{" "}
                      <div className={`practiced-detail-date-picker ${!selectedDate ? "hide-divider" : ""}`}>
                        <DatePicker
                          onChange={changeDate}
                          value={selectedDate}
                          maxDate={new Date()}
                          calendarIcon={null}
                          clearIcon={null}
                          isOpen={isDate}
                          format="dd-MM-yyyy"
                          dayPlaceholder=""
                          monthPlaceholder=""
                          yearPlaceholder=""
                        />
                      </div>
                    </div>

                    <button
                      type="button"
                      className="filter-date-btn"
                      onClick={() => setIsDate(!isDate)}
                    >
                      <img src={CalenderIcon} alt="Image" /> Filter Date
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Card.Header>

           <Card.Body>
  {isLoading ? (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
      
       <Spinner/>
      
    </div>
  ) : activeData ? (
    <TabTables
      data={activeData}
      getQuestionType={getQuestionType}
      activeDate={activeDate}
    />
  ) : (
    <EmptyData text={"No Data Found"} />
  )}
</Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default PracticedDetail;

/**
 * Tab Data — now directly maps data[activeDate] instead of using tabs
 */
const TabTables = React.memo(function TabTables({ data, getQuestionType,activeDate }) {
  const [category, setCategory] = React.useState(null);

  const toggleCollapse = (type) => {
    setCategory(category === type ? null : type);
  };

  const collapseLabel = (type) => {
    return category === type ? "Close" : "View";
  };

  const shouldCollapseOpen = (type) => {
    return category === type;
  };

  return (
    <div className="table-responsive visibility-visible">
      <table className="desktop-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Question Type</th>
            <th>Question Count</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {Object.keys(data).map((type, k) => {
            return (
              <React.Fragment key={k}>
                <tr>
                  <td>{k + 1}</td>
                  <td>{getQuestionType(type)}</td>
                  <td>{Object.keys(data[type]).length}</td>
                  <td>
                    <a
                      href="javascript:void(0)"
                      className="nav-link"
                      onClick={() => toggleCollapse(type)}
                    >
                      <span className="view-btn">
                        {collapseLabel(type)}{" "}
                        <img
                          className="view-btn-icon"
                          src={ArrowIcon}
                          alt="Badge"
                        />
                      </span>
                    </a>
                  </td>
                </tr>

                {shouldCollapseOpen(type) && (
                  <tr className="visibility-visible">
                    <td></td>
                    <td colSpan="2">
                      <LoadCategoryQuestions date={activeDate} type={type} />
                    </td>
                    <td></td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
});

const LoadCategoryQuestions = React.memo(function LoadCategoryQuestions({
  date,
  type,
}) {
  const [questions, setQuestions] = React.useState([]);

  React.useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    API({
      method: "GET",
      url: `single/practiceDetail?type=${type}&date=${date}`,
    })
      .then((data) => {
        // don't touch this.
        const qArr = data.data.data.filter((val) => {
          return val.question !== null;
        });
        setQuestions(qArr);
      })
      .catch(() => {});
  };

  return (
    <Collapse in={true}>
      {questions.length > 0 ? (
        <div className="table-responsive visibility-visible">
          <table className="desktop-table">
            <thead>
              <tr>
                <th>Question Title</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {questions.map((item, i) => {
                if (item.question) {
                  return (
                    <tr key={i}>
                      {item?.question?.q_title ? (
                        <td>{item?.question?.q_title}</td>
                      ) : (
                        <td>#{item.question.id}</td>
                      )}
                      <td>
                        <Link
                          className="nav-link"
                           // to={{
                          //   pathname: `/admin/practice-hist/0/${item.question.subcategory_id}/${item.question.id}/1/all/all/all?view=1`,
                          //   state: {
                          //     questions,
                          //     index: i,
                          //   },
                          // }}
                          to={`/admin/practice-hist/0/${item.question.subcategory_id}/${item.question.id}/1/all/all/all?view=1`}
                          state={{
                            questions,
                            index: i,
                          }}
                        >
                          <span className="view-btn">
                            Open{" "}
                            <img
                              className="view-btn-icon"
                              src={ArrowIcon}
                              alt="Badge"
                            />
                          </span>
                        </Link>
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <i className="color-danger">Loading data...</i>
      )}
    </Collapse>
  );
});